import React from 'react';
import '../../styles/style.css'

function TodosError(){
    return(
        <p>Error</p>
    );   
}
export {TodosError};